<template>
    <div >
        <div>
            <el-form label-width="90px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="商品">
                            <el-select v-model="$parentInfo.dialog_shopCart.filter.shop_id"
                                       placeholder="请选择商品"
                                       filterable remote
                                       :remote-method="handleSearchShop"
                                       @change="handleChooseShop"
                                       clearable
                                       style="width:200px">
                                <el-option
                                        v-for="item in $parentInfo.dialog_shopCart.shops"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="单价">
                            <el-input v-model="$parentInfo.dialog_shopCart.filter.unit_price"
                                      placeholder="单价"
                                      clearable
                                      disabled
                                      style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="数量">
                            <el-input v-model="$parentInfo.dialog_shopCart.filter.amount"
                                      placeholder="请输入数量"
                                      clearable
                                      style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="租转买">
                            <el-checkbox v-model="$parentInfo.dialog_shopCart.filter.rentToBuy" @change="handleRentToBuy"></el-checkbox>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="$parentInfo.dialog_shopCart.filter.rentToBuy">
                    <el-col :span="24">
                        <el-form-item label="已租商品">
                            <el-select v-model="$parentInfo.dialog_shopCart.filter.rent_shop_id"
                                       placeholder="请选择已租商品"
                                       filterable remote
                                       @change="handleChooseRentShop"
                                       clearable
                                       style="width:200px">
                                <el-option
                                        v-for="item in $parentInfo.dialog_shopCart.student_rent_shops"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                总价：{{$parentInfo.dialog_shopCart.filter.unit_price*$parentInfo.dialog_shopCart.filter.amount|currency('￥',2)}}
            </el-form>
        </div>
        <div>
            <div class="text-right">
                <el-button type="primary" @click="handleSettleShop()">加入购物车</el-button>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        name: "Dialog_ShopCart",
        data(){
            return{
                filter:{
                    shop_id:'',
                    unit_price:'',
                    amount:0,
                },
                shops:[],
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetShops()
        },
        destroyed(){
            this.$parentInfo.dialog_shopCart.filter.shop_id='';
            this.$parentInfo.dialog_shopCart.filter.unit_price='';
            this.$parentInfo.dialog_shopCart.filter.amount=0;
        },
        methods: {
            handleGetShops(){
                this.$wApi.send(this.$parentInfo.path, 'get_shops', {})
            },
            handleSettleShop(){
                this.$wApi.send(this.$parentInfo.path, 'add_shop_to_cart', {
                    'student_id':this.$parentInfo.student_id,
                    'amount':this.$parentInfo.dialog_shopCart.filter.amount,
                    'shop_id':this.$parentInfo.dialog_shopCart.filter.shop_id,
                    'rentToBuy':this.$parentInfo.dialog_shopCart.filter.rentToBuy,
                    'rent_shop_id':this.$parentInfo.dialog_shopCart.filter.rent_shop_id,

                })
            },
            handleChooseShop(){
                if(this.$parentInfo.dialog_shopCart.filter.shop_id){
                    this.$parentInfo.dialog_shopCart.filter.unit_price=
                        this.$parentInfo.dialog_shopCart.shops[this.$parentInfo.dialog_shopCart.filter.shop_id].price
                }
            },
            handleSearchShop(query){
                this.$wApi.send(this.$parentInfo.path, 'search_shops', {'good_name':query})
            },
            handleRentToBuy(){
                this.$wApi.send(this.$parentInfo.path, 'student_rent_shop', {
                    'student_id':this.$parentInfo.student_id
                })
            },
            handleChooseRentShop(){
                if(this.$parentInfo.dialog_shopCart.filter.rent_shop_id){
                    this.$parentInfo.dialog_shopCart.filter.unit_price=
                        this.$parentInfo.dialog_shopCart.student_rent_shops[this.$parentInfo.dialog_shopCart.filter.rent_shop_id].price;
                    this.$parentInfo.dialog_shopCart.filter.shop_id=this.$parentInfo.dialog_shopCart.student_rent_shops[this.$parentInfo.dialog_shopCart.filter.rent_shop_id].shop_id;
                    this.$parentInfo.dialog_shopCart.filter.amount=1
                }
            }
        }
    }
</script>

<style scoped>

</style>